<template>
  <div class="auto-reg independ-reg">
    <HeroBlock v-bind="hero"></HeroBlock>
    <div class="block">
      <CardBlock :cards="cards"></CardBlock>
      <DescriptionBlock v-bind="description"></DescriptionBlock>
      <LikeBlock v-bind="like"></LikeBlock>
    </div>
    <Toggle :cards="cards" :description="description" :like="like"></Toggle>
    <DoubleDemo :videos="videos" :demo="demoModal"></DoubleDemo>
    <Calculator :calculator="calculator"></Calculator>
  </div>
</template>

<script>
import HeroBlock from "@/components/hero-block";
import CardBlock from "@/components/cards-block";
import DescriptionBlock from "@/components/description-block";
import LikeBlock from "@/components/like-block";
import Toggle from "@/components/toggle";
import DoubleDemo from "@/components/double-videos";
import Calculator from "@/components/calculator";

export default {
  components: {
    HeroBlock,
    CardBlock,
    DescriptionBlock,
    LikeBlock,
    Toggle,
    DoubleDemo,
    Calculator
  },
  data() {
    return {
      hero: {
        title: `Самостоятельная регистрация`,
        paragraphs: [
          `Клиентский сервис для самостоятельного прохождения анкетирования и регистрации <br>
          чеков участниками стимулирующих акций.`,
          `Продукт включает создание веб-портала об акции и систему умных чат-ботов, <br>
          позволяет участникам самостоятельно вводить персональные данные, распознавать <br>
          чеки ирегистрировать покупки.`,
          `Программа расшиярет возможности и преимущества  автоматизированной стойки <br>
          регистрации, выводит взаимодействие с участниками акции на <br>
          качественно новый уровень.`
        ],
        src: require(`@/assets/images/hero2.png`)
      },
      cards: [
        {
          title: `Удобство покупателям`,
          paragraph: `Программа позволяет покупателям зарегистрировать свои покупки, где и когда им удобно. Без установки приложений, <br>
          логинов, паролей и прочих сложностей. Участие в акции становится интересным приключением, время для которого <br>
          каждый выбирает сам. Чеки сканируются камерой телефона, купоны хранятся в электронном виде, и вся информация <br>
          об акции всегда под рукой.`,
          src: require(`@/assets/images/card-self1.svg`)
        },
        {
          title: `Объединяет разные платформы`,
          paragraph: `Программа доступна клиентам на разных платформах. Например, участник может зарегитсрироваться в акции <br>
          при помощи чат-бота, добавить новые чеки на стойке регистрации, скачать или распечатать купоны <br>
          на веб-портале. На каждой платформе доступен абсолютно весь функционал системы.`,
          src: require(`@/assets/images/card-self2.svg`)
        },
        {
          title: `Чат-боты в WhatsApp, Telegram, Viber, VK, FB`,
          paragraph: `Чат-бот - уникальная возможность двухстороннего контакта с каждым участником акции. Система корректно <br>
          выстраивает диалоги с пользователями в любых мессенджерах, распознает чеки по присланному фото, показывает <br>
          призы, рассказывает об акции. Поддержка мессенджеров осуществляется через официальные каналы, в том числе, <br>
          работа WhatsApp происходит через сертифицированного провайдера с обязательной регистрацией официального <br>
          бизнес-аккаунта.`,
          src: require(`@/assets/images/card-self3.svg`)
        },
        {
          title: `Розыгрыш - это шоу`,
          paragraph: `У каждого участника есть персональная страничка розыгрыша, которая показывает выигрышные номера, <br>
          находит нужный купон, формирует зашифрованный QR-код для проверки подлинности участника перед <br>
          вручением приза. Функционал полезен и организаторам розыгрыша: программа позволяет в реальном времени <br>
          выводить на сценический экран выпавшие цифры, подсчитывать и показывать количество купонов в игре <br>
          и автоматически выводить имя победителя.`,
          src: require(`@/assets/images/card-self4.svg`)
        }
      ],
      description: {
        title: `Экономически выгодно`,
        paragraphs: [
          `Внедрение механик самостоятельной регистрации позволяет уменьшить <br>
          или полностью исключить затраты на содержание стойки регистрации, <br>
          оплату регистраторов и печать купонов. `,
          `Сокращаются и косвенные расходы: например, нет необходимости <br>
          хранить "бумажные" согласия на обработку персональных данных.`
        ],
        src: require(`@/assets/images/description2.svg`)
      },
      like: {
        title: `Полезно даже после акции`,
        paragraph: `После окончания акции коммуникация с клиентом сохраняется. Чат-боты продолжают информировать покупателей об акциях и событиях, готовы <br>
        рассказать о любом бутике, режиме работы и даже как добраться до торгового центра. С началом новой акции система начнет новые диалоги <br>
        в мессенджерах сама, оповестит всех участников по email, или СМС.`,
        src: require(`@/assets/images/like2.svg`)
      },
      videos: [
        {
          id: `1`,
          title: `Как работает самостоятельная регистрация с мобильного телефона `,
          src: `https://www.youtube.com/embed/_RQgf6v8SwA`,
          preview: `https://i.ytimg.com/vi/_RQgf6v8SwA/maxresdefault.jpg`,
        },
        {
          id: `2`,
          title: `Как выглядит окно статистики и изменения персональных данных`,
          src: `https://www.youtube.com/embed/4GyFyGShTuU`,
          preview: `https://i.ytimg.com/vi/4GyFyGShTuU/maxresdefault.jpg`,
        }
      ],
      demoModal: {
        promise: `В демонстрационном режиме вы испытаете возможности веб-формы самостоятельной регистрации, оцените удобство регистрирующего чат-бота, 
        <br> познакомитесь с формами статистики и редактирования данных.`,
        paragraph: `Для доступа к демо-версии самостоятельной регистрации и чат-боту Вам <br>
        необходимо перейти на CRM-платформу EventGO! Напишите нам свой имеил <br>
        и мы вышлем на него необходимые ссылки.`,
        mobileParagraph: `Испытайте все возможности программы в демонстрационном режиме и рассчитайте стоимость автоиматизации вашей акции! Откройете эту страницу на компьютере и вам станут доступными демо-режим и калькулятор стоимости.`
      },
      calculator: {
        choseTitle: `Длительность акции`,
        smParagraph: `Помимо самостоятельной регистрации <br>
          необходима ли стойка регистрации <br>
          участников`
      }
    };
  }
};
</script>
